export const Wordmark = ({ className = "", size = "text-[22px]" }) => (
  <span className={`inline-flex items-baseline leading-none tracking-[-0.045em] ${size} ${className}`} aria-label="x1025">
    <span className="font-[380]">x</span>
    <span className="font-[620]">1025</span>
  </span>
);
